
<template>
    <IMG :src="m_Src"
         @click="OnClick"
    />
</template>

<script>
    import Utility from "@/Common/Utility";


    export default {
        data() {
            return {
                m_Src: null,
                virtaulDirecotry:"",
            }
        }
        ,
        props: ["src"],


        computed: {

            
        }
        ,

        methods: {
            OnClick(e) {
                this.$emit("click", e);
            },

            PrepareSrc() {
 
                this.virtaulDirecotry = Utility.GetVirtualDirectory();
                
 
                if (this.src != null && this.src[0] == '/' && this.virtaulDirecotry != ""
                    &&
                    this.src.indexOf("/"+this.virtaulDirecotry+"/") != 0
                ) {
                    this.m_Src = "/" + this.virtaulDirecotry + this.src;
                }
                else {
                    this.m_Src = this.src;
                }
            },
                
        },

        created() {
             

            this.PrepareSrc();

        },

        watch: {
            src(newVal) {

                this.PrepareSrc();
            }
        }


    }
</script>
 